import { useMemo } from 'react';

import { LoanEditorActionsEnum } from 'constants/loanActionEditor';

import { sortByDisplayOrder } from './utils';

const useGroupedLoanActions = loanActions =>
  useMemo(() => {
    const result = loanActions.reduce(
      (acc, actionData) => {
        const savePendingChangesActionType = actionData.loanActionTypes.find(
          ({ type }) => type === LoanEditorActionsEnum.SAVE_PENDING_CHANGES,
        );

        if (savePendingChangesActionType) {
          if (acc.isSavePendingChangesActionExist) {
            return acc;
          }

          acc.isSavePendingChangesActionExist = true;
          acc.filteredLoanActions.push({
            ...actionData,
            isHasSavePendingChangesAction: true,
            grantedCancel: !!savePendingChangesActionType.grantedCancel,
            grantedSave: !!savePendingChangesActionType.grantedSave,
          });

          return acc;
        }

        acc.filteredLoanActions.push(actionData);

        return acc;
      },
      {
        filteredLoanActions: [],
        isSavePendingChangesActionExist: false,
      },
    );

    const sorted = [...result.filteredLoanActions].sort(sortByDisplayOrder);

    const groups = sorted.reduce((acc, action) => {
      const groupKey = action.group || '';

      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }

      acc[groupKey].push(action);

      return acc;
    }, {});

    const topLevel = groups[''] || [];
    const namedGroups = Object.entries(groups)
      .filter(([key]) => key !== '')
      .sort(([a], [b]) => a.localeCompare(b));

    return { topLevel, namedGroups };
  }, [loanActions]);

export default useGroupedLoanActions;
